import React, { useEffect, useState, useRef } from 'react';

import { QuickFilterButton, Button } from '@hpstellar/core';
import { ChevronDown, ChevronUp } from '@hpstellar/icons';

import './filter-view.less';

export default function FilterView({ filters, onSelectFacet }) {
    const ref = useRef(null);
    const [more, setMore] = useState(false);
    const [expand, setExpand] = useState(false);

    useEffect(() => {
        if (!ref.current) return null;
        const resizeObserver = new ResizeObserver(() => {
            setMore(ref.current.clientHeight >= 160);
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div className="vwaFiltersView">
            <div className={`vwaFiltersView-list${expand ? ' vwaFiltersView-fullHeight' : ''}`} ref={ref}>
                {filters.map((f, i) => (
                    <QuickFilterButton
                        key={`${f.displayName}-${i}`}
                        onClick={onSelectFacet(f.key, f.urlValue)}
                        isActive
                    >
                        {f.displayName}
                    </QuickFilterButton>
                ))}
            </div>
            {more && (
                <div className="vwaFiltersView-more">
                    <Button
                        onClick={() => setExpand(!expand)}
                        color="dark"
                        variation="tertiary"
                        endIcon={expand ? <ChevronUp size="s" /> : <ChevronDown size="s" />}
                    >
                        {expand ? 'SHOW LESS' : 'SEE ALL APPLIED FILTERS'}
                    </Button>
                </div>
            )}
        </div>
    );
}
